"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mainNav = void 0;

var _swatches = require("../swatches");

var mainNav = {
  headerColor: _swatches.monochrome.white,
  dotBackground: _swatches.monochrome.white,
  background: _swatches.monochrome.superDark,
  color: _swatches.monochrome.white,
  itemBackground: _swatches.monochrome.dark,
  itemBackgroundHover: "rgba(".concat(_swatches.monochrome.dark_rgba, ", 0.6)"),
  countColor: _swatches.monochrome.white,
  countColorHover: _swatches.monochrome.black,
  countColorActive: _swatches.monochrome.black,
  countBackground: _swatches.monochrome.dark,
  countBackgroundHover: _swatches.monochrome.white,
  countBackgroundActive: _swatches.monochrome.white,
  clickableOpacity: 0.7,
  clickableOpacityHover: 1,
  clickableOpacityActive: 1
};
exports.mainNav = mainNav;
//# sourceMappingURL=mainNav.js.map